import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import SubscribeForm from '../components/forms/SubscribeForm'
import LGChairman from "../components/articles/LGChairman";
import LGCouncillor from "../components/articles/LGCouncillor";
import { useParams, useNavigate } from "react-router-dom";
import { BiArrowBack } from 'react-icons/bi';
import '../components/articles/Article.css'
import Layout from '../components/layout/Layout';

const Article = () => {
    const { slug } = useParams();

    const articles = {
        'lga-chairman': {
            title: 'What does a Local Government Chairman do?',
            component: <LGChairman />,
        },
        'lga-councilor': {
            title: 'What does a Local Government Councillor do?',
            component: <LGCouncillor />,
        },
        'how-to-vote': {
            title: 'How do I vote?',
            component: null,
        },
        'why-should-i-vote': {
            title: 'Why should I vote?',
            component: null,
        }
    };

    const article = articles[slug];
    const navigate = useNavigate();

    return (

        <Layout>

            <Header />
            <div className="flex flex-col grow border-t border-neutral-50 mt-3 px-6">
                {article && <section className="flex flex-col grow rounded-xl gap-1.5 py-8">

                    <button onClick={() => navigate(-1)} className="flex gap-1 items-center">
                        <BiArrowBack className="h-3" />
                        <h5 className="text-sm font-medium mt-0.5">Back</h5>
                    </button>
                    <h1 className="text-xl pt-6 pb-3 font-semibold text-gray-900">{article.title}</h1>

                    {
                        article.component && <div className="article space-y-2">
                            <p className="italic text-xs text-gray-900">Note: This is an AI generated article from Google Gemini.</p>
                            {article.component}
                        </div>
                    }

                </section>}
            </div>

            <div className="pt-8 space-y-8">

                <SubscribeForm />
                <Footer />
            </div>

        </Layout>
    )
}

export default Article;
